import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { FaceButton, FaceButtonColor, FaceButtonSize } from '@common/toolbox';

interface Props {
  isInApp: boolean;
  disabled: boolean;
  inquiry_path_message: string;
  addQuestion: () => void;
  moveToInquiryHistory: () => void;
}

export const DescriptionArea: React.FC<React.PropsWithChildren<Props>> = ({
  isInApp,
  disabled,
  inquiry_path_message,
  addQuestion,
  moveToInquiryHistory,
}) => {
  return (
    <>
      <Description>
        상품 관련 문의는 판매자가 상세히 답변드립니다.
        <br />

        {isInApp ? (
          <div>
            답변은 <a onClick={moveToInquiryHistory}>{inquiry_path_message}</a>
            에서 확인하실 수 있습니다.
          </div>
        ) : (
          `답변은 ${inquiry_path_message} 에서 확인하실 수 있습니다.`
        )}
      </Description>
      <div>
        <FaceButton
          className='inquiry_button'
          disabled={disabled}
          onClick={addQuestion}
          color_type={FaceButtonColor.GRAY900}
          size_type={FaceButtonSize.S15_H48}
        >
          상품 문의하기
        </FaceButton>
      </div>
    </>
  );
};

const Description = styled.p`
  width: 310px;
  padding-top: 12px;
  font-size: 13px;
  line-height: 15.6px;
  color: ${vars.color.textTertiary};
  word-break: keep-all;

  b {
    font-weight: 600;
    color: ${vars.color.textSecondary};
  }

  a {
    text-decoration: underline;
    color: ${vars.color.textSecondary};
  }
`;
